import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { ProfileImage } from '../../../editor/features/liveChat/components/ProfileImage/ProfileImage';
import './ProfilePictureEditor.pcss';

const MAX_FILE_SIZE_IN_MB = 8;
const MAX_FILE_SIZE = MAX_FILE_SIZE_IN_MB * 1024 * 1024;

type Props = {
  profilePictureUrl: string | undefined;
  onChange: (imageFile: File) => void;
};

export const ProfilePictureEditor = (props: Props) => {
  const { profilePictureUrl, onChange } = props;
  const [errorMessage, setErrorMessage] = useState('');

  const { getRootProps, getInputProps } = useDropzone({
    accept: ['image/jpg', 'image/jpeg', 'image/gif', 'image/png'],
    maxSize: MAX_FILE_SIZE,
    onDrop: (files: File[], rejectedFiles: File[]) => {
      setErrorMessage('');
      if (files.length) {
        onChange(files[0]);
      } else if (rejectedFiles.length) {
        if (rejectedFiles[0].size > MAX_FILE_SIZE) {
          setErrorMessage(`File exceeds ${MAX_FILE_SIZE_IN_MB}MB`);
        } else {
          setErrorMessage('Invalid file type');
        }
      }
    },
  });

  return (
    <div className="profile-picture-editor">
      <ProfileImage
        altText="Profile Image"
        profilePictureUrl={profilePictureUrl}
        className="profile-picture-editor__profile-image"
        css={{ container: 'profile-picture-editor__profile-image-container' }}
      />
      <div className="profile-picture-editor__upload-area" {...getRootProps()}>
        <input type="file" {...getInputProps()} />
        <button className="profile-picture-editor__update-image-button">
          <i className="fas fa-camera profile-picture-editor__update-image-button-icon" />
          Update
        </button>
        <div className="profile-picture-editor__error-message">
          {errorMessage}
        </div>
      </div>
    </div>
  );
};
